var render, staticRenderFns
import script from "./InlineSaveField.vue?vue&type=script&lang=js"
export * from "./InlineSaveField.vue?vue&type=script&lang=js"
import style0 from "./InlineSaveField.vue?vue&type=style&index=0&id=58d1248a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d1248a",
  null
  
)

export default component.exports